export default __webpack_public_path__ + "static/media/LogoWhite.d2c3f949.svg";